export default __webpack_public_path__ + "static/media/city-court-with-birds.e77bbffe.gif";